import * as Icons from "lucide-react";

export function Eyebrow({ children }) {
  return <div className="text-xs uppercase font-bold tracking-[0.2em] text-brand mb-3">{children}</div>;
}

export function SectionHeading({ eyebrow, title, subtitle, center, light }) {
  return (
    <div className={`${center ? "text-center mx-auto max-w-2xl" : "max-w-2xl"} mb-10 lg:mb-14`}>
      {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
      <h2 className={`text-2xl sm:text-3xl lg:text-4xl font-heading font-bold tracking-tight ${light ? "text-white" : "text-navy-heading"}`}>{title}</h2>
      {subtitle && <p className={`mt-4 text-base sm:text-lg leading-relaxed ${light ? "text-slate-300" : "text-slate-600"}`}>{subtitle}</p>}
    </div>
  );
}

export function DynIcon({ name, className }) {
  const Icon = Icons[name] || Icons.Car;
  return <Icon className={className} />;
}

export function Stars({ n = 5, className = "w-4 h-4" }) {
  return (
    <div className="flex gap-0.5">
      {Array.from({ length: 5 }).map((_, i) => (
        <Icons.Star key={i} className={`${className} ${i < n ? "text-saffron fill-saffron" : "text-slate-300"}`} />
      ))}
    </div>
  );
}
